import { useState, useEffect } from "react";
import { colors } from "../theme";

interface AnimatedStatProps {
  value: number;
  suffix: string;
  label: string;
  isVisible: boolean;
  isDark: boolean;
}

export function AnimatedStat({
  value,
  suffix,
  label,
  isVisible,
  isDark,
}: AnimatedStatProps) {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000;
    const steps = 60;
    const increment = value / steps;
    let current = 0;

    const timer = setInterval(() => {
      current += increment;
      if (current >= value) {
        setDisplayValue(value);
        clearInterval(timer);
      } else {
        setDisplayValue(Math.floor(current * 10) / 10);
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [isVisible, value]);

  return (
    <div
      className={`text-center transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
    >
      <div
        className="font-light tracking-tight transition-colors duration-[2000ms]"
        style={{ fontSize: "4rem", color: isDark ? colors.cyan : colors.blue }}
      >
        {displayValue.toFixed(value % 1 !== 0 ? 1 : 0)}
        {suffix}
      </div>
      <div
        className="text-sm uppercase tracking-widest mt-2 transition-colors duration-[2000ms]"
        style={{ color: isDark ? colors.base01 : colors.base1 }}
      >
        {label}
      </div>
    </div>
  );
}
